import React from 'react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';

import { UGMap } from 'src/uglib_utils/map';

function AreaMap ({image, width, height, description, bounds}) {
    


    /**
     * @param {array} bounds A list of bounds as returned from 
     * @param {Element} area_map DOM element for the map.
     */
    function drawBounds(bounds, area_map) {
        bounds.forEach((bound) => {
            area_map.drawBound(bound);
        })
    }

	useEffect(() => {
        let canvas = document.getElementById('map');

        if(canvas) {
            // Load the map and draw the bounds on it.
            const area_map = new UGMap(canvas, image, width, height);
            drawBounds(bounds, area_map);

            /**
             * Resize the map when the window is resized.
             */
            window.addEventListener('resize', function() {
                area_map.fill();
                drawBounds(bounds, area_map);
            });
        }
	}, [image, width, height, bounds]);

	return (<>
		<div>
            <canvas id="map">
                {description}
            </canvas>
        </div>
	</>)
}

AreaMap.propTypes = {
    image: PropTypes.string,
    description: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    bounds: PropTypes.array
}

AreaMap.defaultProps = {
    bounds: []
}

export default AreaMap